import React from "react";
import { Row, Col, Progress } from "reactstrap";
import { Link } from "react-router-dom";
/*=============================================
=            order List Comments              =
=============================================*/

export const config = {
  container: [
    {
      label: "",
      key: "TransportMode",
      minWidth: 40,
      maxWidth: 40,
      custom: (value) => {
        return (
          <em
          style={{
            color: "#000a2e",
            fontSize: "30px",
            // marginLeft: "3px",
          }}
          className={
            "icon-container"
          }
        ></em>
        );
      },
    },

    {
      label: "contianer_num",
      key: "ContainerId",
      minWidth: 180,
      maxWidth: 180,
      className: "col-md-3 col-lg-2 col-sm-6",
      custom: (value) => (
        <Link
          style={{ color: "#0561fc", fontWeight: "bold" }}
          to={"/container-detail-components/" + value.ContainerId}
        >
          {value.ContainerNo}
        </Link>
        // <a style={{ color: "red" }}>{value.NoContenedor}</a>
      ),
    },
    {
      label: "status",
      key: "Status",
      minWidth: 0,
      maxWidth: 0,
      custom: (value) => (
        // <span style={{ color: "#0561fc", fontWeight: 'bold' }}>{value.Status}</span>
        <span class="badge badge-euro">{value.Status}</span>
        // <a style={{ color: "red" }}>{value.NoContenedor}</a>
      ),
      className: "col-md-3 col-lg-2 col-sm-6",
    },
    {
      label: "shipment_num",
      key: "ShipmentNumber",
      minWidth: 220,
      maxWidth: 220,
      className: "col-md-3 col-lg-1 col-sm-6",
    },
    {
      label: "company",
      key: "NameCustomer",
      minWidth: 220,
      maxWidth: 220,
      className: "col-md-3 col-lg-1 col-sm-6",
    },
    {
      label: "shipper",
      xls: true,
      minWidth: 220,
      maxWidth: 220,
      key: "NameShipper",
      className: "col-md-3 col-lg-1 col-sm-6",
    },
    {
      label: "order_ref",
      xls: true,
      type: 7,
      key: "RefCustomer",
      minWidth: 220,
      maxWidth: 220,
      className: "col-md-2 col-lg-1 col-sm-1",
    },
    {
      label: "destination",
      xls: true,
      type: 7,
      minWidth: 220,
      maxWidth: 220,
      key: "POD",
      className: "col-md-2 col-lg-1 col-sm-1",
    },
    {
      label: "delivery_address",
      xls: true,
      type: 7,
      key: "DeliveryLocation",
      className: "col-md-2 col-lg-1 col-sm-1",
    },
    {
      label: "etd",
      xls: true,
      data: { link: false, progress: false, icon: false, status: false },
      key: "ETD",
      className: "col-md-3 col-lg-1 col-sm-6",
    },
    {
      label: "eta",
      xls: true,
      data: { link: false, progress: false, icon: false, status: false },
      link: "/shipments-details/",
      key: "ETA",
      className: "col-md-3 col-lg-1 col-sm-6",
    },
  ],
  shipment: [
    {
      label: "",
      key: "TransportMode",
      minWidth: 60,
      maxWidth: 60,
      custom: (value) => {
        return (
          <div
            style={{
              textAlign: "left",
              paddingLeft: value.TransportModeCode === 2 ? "5%" : "",
            }}
          >
            {value.TransportModeCode ? (
              <em
                style={{
                  color: "#000a2e",
                  fontSize: "30px",
                  // marginLeft: "3px",
                }}
                className={
                  value.TransportModeCode === 2
                    ? "icon-air-shipment icons-front-module"
                    : value.TransportModeCode === 1
                    ? "icon-sea-shipment icons-front-module"
                    : value.TransportModeCode ===4
                    ? "icon-shipment-rail icons-front-module"
                    : "icon-ground-shipment icons-front-module"
                }
              ></em>
            ) : (
              <em
                style={{
                  color: "#000a2e",
                  fontSize: "30px",
                  // marginLeft: "3px",
                }}
                className={"icon-sea-shipment icons-front-module"}
              ></em>
            )}
          </div>
        );
      },
    },
    {
      label: "progress",
      xls: false,
      data: { link: false, progress: true, icon: false, status: false },
      key: "Progress",
      minWidth: 100,
      maxWidth: 100,
      className: "col-md-3 col-lg-1 col-sm-6",
      custom: (value) => (
        <div>
          <center style={{ marginBottom: "4px" }}>
            {/* {value.Progress < 50 ? <span style={{ color: '#F0504F', fontWeight: 'bold', fontSize: '12px' }}>Demorado</span> :
            <span style={{ color: '#68D990', fontWeight: 'bold', fontSize: '12px' }}>A tiempo</span>} */}
          </center>
          <Progress
            color="pink"
            // color={
            //   value.Progress < 50
            //     ? "danger"
            //     : "pink"
            // }
            value={value.Progress}
          />
        </div>

        // <a style={{ color: "red" }}>{value.NoContenedor}</a>
      ),
    },
    {
      label: "status",
      key: "Status",
      minWidth: 0,
      maxWidth: 0,
      custom: (value) => (
        // <span style={{ color: "#0561fc", fontWeight: 'bold' }}>{value.Status}</span>
        <span class="badge badge-euro">{value.Status}</span>
        // <a style={{ color: "red" }}>{value.NoContenedor}</a>
      ),
      className: "col-md-3 col-lg-2 col-sm-6",
    },
    {
      label: "shipment_num",
      key: "ShipmentId",
      minWidth: 220,
      maxWidth: 220,
      className: "col-md-3 col-lg-2 col-sm-6",
      custom: (value) => (
        <Link
          style={{ color: "#0561fc", fontWeight: "bold" }}
          to={"/shipments-details/" + value.ShipmentId}
        >
          {value.ShipmentNumber}
        </Link>
        // <a style={{ color: "red" }}>{value.NoContenedor}</a>
      ),
    },
    {
      label: "transport_order",
      key: "TransportOrderNo",
      xls: true,
      minWidth: 220,
      maxWidth: 220,
      custom: (value) => (
        // <span style={{ color: "#0561fc", fontWeight: 'bold' }}>{value.Status}</span>
        <span>{value.TransportOrderNo}</span>
        // <a style={{ color: "red" }}>{value.NoContenedor}</a>
      ),
      className: "col-md-3 col-lg-1 col-sm-6",
    },
    {
      label: "company",
      key: "CustomerName",
      minWidth: 220,
      maxWidth: 220,
      className: "col-md-3 col-lg-1 col-sm-6",
    },
    {
      label: "shipper",
      key: "ShipperName",
      minWidth: 220,
      maxWidth: 220,
      className: "col-md-3 col-lg-1 col-sm-6",
    },
    {
      label: "order_ref",
      xls: true,
      type: 7,
      key: "ServicesOrdersNo",
      minWidth: 220,
      maxWidth: 220,
      className: "col-md-2 col-lg-1 col-sm-1",
    },
    {
      label: "container",
      xls: true,
      type: 7,
      minWidth: 220,
      maxWidth: 220,
      key: "Containers",
      className: "col-md-2 col-lg-1 col-sm-1",
    },
    {
      label: "HBL/AWB",
      xls: true,
      type: 7,
      key: "HBL_HAWB",
      className: "col-md-2 col-lg-1 col-sm-1",
    },
    {
      label: "MBL/ MAWB",
      xls: true,
      type: 7,
      key: "MBL_AWB_PRO",
      className: "col-md-2 col-lg-1 col-sm-1",
    },
    {
      label: "origin",
      xls: true,
      data: { link: false, progress: false, icon: false, status: false },

      key: "POL",
      // id2: "PODName",
      className: "col-md-3 col-lg-1 col-sm-6",
    },
    {
      label: "destination",
      xls: true,
      data: { link: false, progress: false, icon: false, status: false },

      key: "POD",
      // id2: "PODName",
      className: "col-md-3 col-lg-1 col-sm-6",
    },
    {
      label: "etd",
      xls: true,
      data: { link: false, progress: false, icon: false, status: false },
      key: "ETD",
      className: "col-md-3 col-lg-1 col-sm-6",
    },
    {
      label: "eta",
      xls: true,
      data: { link: false, progress: false, icon: false, status: false },
      key: "ETA",
      className: "col-md-3 col-lg-1 col-sm-6",
    },
  ],
  transport: [
    {
      label: "",
      key: "TransportMode",
      minWidth: 60,
      maxWidth: 60,
      custom: (value) => {
        return (
          <div
            style={{
              textAlign: "left",
              paddingLeft: value.TransportModeId === 2 ? "5%" : "",
            }}
          >
            {value.TransportModeId ? (
              <em
                style={{
                  color: "#000a2e",
                  fontSize: "30px",
                  // marginLeft: "3px",
                }}
                className={
                  value.TransportModeId === 2
                    ? "icon-air-shipment icons-front-module"
                    : value.TransportModeId === 1
                    ? "icon-sea-shipment icons-front-module"
                    : "icon-ground-shipment icons-front-module"
                }
              ></em>
            ) : (
              <em
                style={{
                  color: "#000a2e",
                  fontSize: "30px",
                  // marginLeft: "3px",
                }}
                className={"icon-sea-shipment icons-front-module"}
              ></em>
            )}
          </div>
        );
      },
    },

    {
      label: "number",
      key: "TransportPlanNo",
      minWidth: 195,
      maxWidth: 200,
      custom: (value) => (
        <Col md={12} xl={12}>
          <Row>
            <Col md={12}>
              <Link
                className="link-euro"
                to={"/tp-detail-view/" + value.TransportPlanId}
              >
                {value.TransportPlanNo}
              </Link>
            </Col>
          </Row>
        </Col>
      ),
    },
    // { label: 'Plan de transporte No.', key: 'TransportPlanNo', minWidth: 180 },
    {
      label: "status",
      key: "Status",
      minWidth: 175,
      maxWidth: 200,
      custom: (value) => (
        // <Button style={{width: value.Status === 'Pendiente Confirmación'?'auto': ''}} className={'btn-oval'} color={'Butoom'} onClick={() => { }}>{value.Status}</Button>
        <span class="badge badge-euro">{value.Status}</span>
      ),
    },
    { label: "company", key: "CustomerName", minWidth: 140, maxWidth: 200 },

    { label: "supplier", key: "Suppliers", minWidth: 130, maxWidth: 200 },
    { label: "service_type", key: "ServiceType", minWidth: 140, maxWidth: 200 },
    { label: "planning", key: "PlanningDate", minWidth: 140, maxWidth: 200 },
    {
      label: "transport_order",
      key: "TransportOrderNo",
      minWidth: 175,
      maxWidth: 200,
    },
    { label: "order_ref", key: "RefOrderNumber", minWidth: 175, maxWidth: 200 },
  ],
  pedido: [
    {
      label: "",
      key: "TransportMode",
      minWidth: 60,
      maxWidth: 60,
      custom: (value) => {
        return (
          <div
            style={{
              textAlign: "left",
              paddingLeft: value.TransportModeId === 2 ? "5%" : "",
            }}
          >
            {value.TransportModeId ? (
              <em
                style={{
                  color: "#000a2e",
                  fontSize: "30px",
                  // marginLeft: "3px",
                }}
                className={
                  value.TransportModeId === 2
                    ? "icon-air-shipment icons-front-module"
                    : value.TransportModeId === 1
                    ? "icon-sea-shipment icons-front-module"
                    : "icon-ground-shipment icons-front-module"
                }
              ></em>
            ) : (
              <em
                style={{
                  color: "#000a2e",
                  fontSize: "30px",
                  // marginLeft: "3px",
                }}
                className={"icon-sea-shipment icons-front-module"}
              ></em>
            )}
          </div>
        );
      },
    },
    {
      label: "reference",
      key: "RefCustomer",
      minWidth: 150,
      maxWidth: 200,
      custom: (value) => (
        <Col md={12} xl={12}>
          <Row>
            <Col md={12}>
              <Link
                className="link-euro"
                to={"/so-detail-view/" + value.ServiceOrderId}
              >
                {value.RefCustomer}
              </Link>
              {/* <Link className='link-euro' to="#">{value.RefCustomer}</Link> */}
            </Col>
          </Row>
        </Col>
      ),
    },
    { label: "request", key: "OrderNumber", minWidth: 200 },
    {
      label: "status",
      key: "Status",
      minWidth: 150,
      maxWidth: 200,
      custom: (value) => (
        // <Button  className={value.StatusId === 13 ? 'btn-estatus btn-oval _gray_button' : ' btn-estatus btn-oval'} color={mapColor[value.StatusId] ? mapColor[value.StatusId] : 'complementary'} onClick={() => { }}>{value.Status}</Button>
        // <span class="badge badge-euro">{value.Status}</span>
        <span className={value.StatusId !== 71 ? "badge badge-euro m1" : "badge badge-euro-created m-1"}>{value.Status}</span>
      ),
    },
    { label: "company", key: "CustomerName", minWidth: 200 },
    { label: "supplier", key: "SupplierName", minWidth: 200 },
    { label: "consignee", key: "ConsigneeName", minWidth: 200 },

    // { label: 'Descripción general de la mercancía', key: 'DescriptionGoods', minWidth: 150 },
    // { label: 'Tramo contratado', key: 'FreightTerm', minWidth: 150 },
    { label: "creation_date", key: "SOCreationDate", minWidth: 150 },
    {
      label: "required_at_destination",
      key: "RequiredDateDestination",
      minWidth: 180,
    },
  ],
  pos: [
    {
      label: "po_no",
      key: "PONumber",
      minWidth: 150,
      maxWidth: 200,
      custom: (value) => (
        <Col md={12} xl={12}>
          <Row>
            <Col md={12}>
              <Link className="link-euro" to={"/po-detail-view/" + value.POId}>
                {value.PONumber}
              </Link>
            </Col>
          </Row>
        </Col>
      ),
    },
    {
      label: "status",
      key: "Status",
      minWidth: 150,
      maxWidth: 200,
      // custom: (value) => <span class="badge badge-euro">{value.Status}</span>,
      custom: (value) => <span className={value.StatusId !== 71 ? "badge badge-euro m1" : "badge badge-euro-created m-1"}>{value.Status}</span>,
    },
    { label: "company", key: "CustomerName", minWidth: 200 },
    { label: "shipper", key: "SupplierName", minWidth: 200 },
    {
      label: "consignee",
      key: "ConsigneeName",
      minWidth: 200,
    },
    {
      label: "transport_mode",
      key: "TransportMode",
      minWidth: 180,
    },
    {
      label: "required_at_destination",
      key: "RequiredDestinationDate",
      minWidth: 180,
    },
    { label: "creation", key: "CreateDate", minWidth: 150 },
  ],
};
